import { useEffect, useState } from "react";
import AppTabs, { TabItem } from "../../../../commons/components/Tabs";
import { useLocation } from "react-router";
import { useAppSelector } from "../../../../hooks/app";
import {
  AppAvatar,
  AppBorderBox,
  AppBox,
  AppBreadCrumbs,
  AppButton,
  AppPaper,
  AppSkeletonHeader,
  AppTitle,
} from "../../../../commons/components";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import { Can } from "../../../../casl/Can";
import { RolePolicyActionEnum } from "../../../../commons/enums/role-policy-action.enum";
import { ManageFootballTeam } from "../../../../commons/models/football/admin/manage-football-team";
import { BreadCrumbItem } from "../../../../commons/components/BreadCrumbs";

interface SubTeamManageDetailHeaderProps {
  onEditSubTeam: (event?: Event) => void;
}

export default function SubTeamManageDetailHeader({ onEditSubTeam }: SubTeamManageDetailHeaderProps) {
  const [currentTab, setCurrentTab] = useState("");
  const [activeItem, setActiveItem] = useState<TabItem>();
  const [crumbs, setCrumbs] = useState<BreadCrumbItem[]>([]);
  const location = useLocation();
  const { subTeamInfo, subTeamInfoStatus } = useAppSelector((state) => state.footballManageSubTeam);

  useEffect(() => {
    const url = location.pathname.split("/");
    setCurrentTab(url[url.length - 1]);
  }, [activeItem, location.pathname]);

  useEffect(() => {
    if (subTeamInfo.id) {
      setCrumbs([
        {
          label: subTeamInfo.parent.name,
          href: `/manage/teams/${subTeamInfo.parent.id}/sub-teams`,
        },
        {
          label: subTeamInfo.name,
        },
      ]);
    }
  }, [subTeamInfo]);

  useEffect(() => {
    const lastPathSegment = location.pathname.split("/").pop();
    if (!isNaN(Number(lastPathSegment))) {
      setCurrentTab("profile");
    }
  }, [location.pathname]);

  const tabItems = [
    {
      label: "Profile",
      value: "profile",
      href: "profile",
    },
    {
      label: "Squad",
      value: "squad",
      href: "squad",
    },
    {
      label: "Events",
      value: "events",
      href: "events",
    },
    {
      label: "Statistics",
      value: "statistics",
      href: "statistics",
    },
    {
      label: "Standings",
      value: "standings",
      href: "standings",
    },
  ];

  return (
    <AppPaper shadow="xs" padding="none">
      {subTeamInfoStatus === StatusEnum.Loading ? (
        <AppSkeletonHeader withoutBackground />
      ) : (
        <>
          <AppBreadCrumbs px="md" py="2xs" crumbs={crumbs} />
          <AppBorderBox border={["Top", "Bottom"]}>
            <AppBox alignItems="center" justifyContent="space-between" p="sm">
              <AppBox alignItems="center" gap="xs">
                <AppAvatar username={subTeamInfo.name} size="2xl" src={subTeamInfo.logo || ""} />
                <AppTitle as="h4">{subTeamInfo.name}</AppTitle>
              </AppBox>
              <Can I={RolePolicyActionEnum.UPDATE} this={new ManageFootballTeam(subTeamInfo.parent)}>
                <AppButton variant="light" label="Edit Sub-team Info" onClick={onEditSubTeam} />
              </Can>
            </AppBox>
          </AppBorderBox>
        </>
      )}
      <AppBox p="sm">
        <AppTabs
          as="a"
          onClick={(e) => {
            setActiveItem(e);
            window.scrollTo(0, 0);
          }}
          activeValue={currentTab}
          tabItems={tabItems}
        />
      </AppBox>
    </AppPaper>
  );
}
